import { render } from "./Challenges.vue?vue&type=template&id=1bba2a55"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"

import "./Challenges.vue?vue&type=style&index=0&id=1bba2a55&lang=css"
script.render = render

export default script